export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage" as const,
    storeAuthStateInCookie: false,
  },
};

export const loginScopes: string[] = [
  "User.Read",
  "Tasks.ReadWrite",
  "Group.Read.All",
  "Notes.Read.All",
  "Files.ReadWrite.All",
  "Mail.Read",
  "Calendars.Read",
  "Sites.Read.All",
  "Team.ReadBasic.All",
];

export const loginRequest = {
  scopes: loginScopes,
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};